/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/30/18
 * Copyright All Rights Reserved
 */

import {
  TOKEN_REQUEST,
  TOKEN_RESPONSE,
  TOKEN_DESTROY,
} from 'constants/actionTypes';

const initialState = {
  errorMessage: '',
  isFetching: false,
  value: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOKEN_REQUEST:
      return {
        ...state,
        errorMessage: '',
        isFetching: true,
        value: '',
      };
    case TOKEN_RESPONSE:
      if (action.error) {
        return { ...state, errorMessage: action.payload.message, isFetching: false };
      }
      return { ...state, isFetching: false, value: action.payload.token };
    case TOKEN_DESTROY:
      return { ...state, value: '' };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./js/reducers/tokenReducer.js